import React from "react";
import bgImage from "../Assets/login_background_image.jpg";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import styles from "../Styles/SignInAdmin.module.css";
import LoginForm from "../Components/SignInCompAdmin";


export const SignIn = () => {
  const backgroundStyle = {
    backgroundImage: `url(${bgImage})`,
    backgroundPosition: "center center",
    backgroundRepeat: "no-repeat",
    width: "100%",
    minHeight: "100vh",
    backgroundSize: "cover",
    paddingTop: "130px",
    paddingBottom: "20px",
  };

  

  return (
    <div style={backgroundStyle}>
      <div className={styles.logo_wrapper}>
        <h1 className={styles.company_logo}>VroPay Admin</h1>
      </div>
      <Container>
        <Row className="justify-content-center">
          <Col xs={12} sm={10} md={8} lg={6}>
            <div className={styles.signin_form_wrapper}>
              {/* Company Logo */}

              {/* Login Form */}
              <LoginForm />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};
